var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMapSearchRunIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.74512 11.0003L0.944087 3.78969C0.714653 1.72611 2.83924 0.210249 4.71582 1.10013L20.5561 8.60382C22.5785 9.56135 22.5785 12.4392 20.5561 13.3967L4.71582 20.9004C2.83924 21.789 0.714653 20.2745 0.944087 18.2109L1.74512 11.0003ZM1.74512 11.0003H11.0286",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMapSearchRunIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/map-search-run-icon.88eb2146.svg";
export { ForwardRef as ReactComponent };